export default {"src":"/_next/static/media/main-logo.a63a8806.svg","height":166,"width":693,"blurWidth":0,"blurHeight":0};